import { ContextMenuItemView, UnitContextMenuClickParams } from '@mark43/cad-api';
import { ContextMenuItem } from '../context-menus/components/context-menu-item';
import { useFullscreenModalControls } from '../modals/context/modal-context-provider';

export function EndEmergencyItem({
    contextMenuItemView,
    clickParams,
}: {
    contextMenuItemView: ContextMenuItemView;
    clickParams: UnitContextMenuClickParams;
}): React.ReactElement {
    const modalControls = useFullscreenModalControls();

    return (
        <ContextMenuItem
            data-pendo-id="menu-item-end-emergency"
            contextMenuItemView={contextMenuItemView}
            onSelect={() =>
                modalControls.open({
                    type: 'END_UNIT_EMERGENCY_MODAL',
                    props: {
                        unit: clickParams,
                    },
                })
            }
        />
    );
}
